import React from 'react';
import { Tabs, TabsList, TabsTrigger } from './Tabs';
import { ChevronRight } from 'lucide-react';
interface SectionBlockProps {
  title: string;
  categories: string[];
  children: React.ReactNode;
  onMore?: () => void;
}
export function SectionBlock({
  title,
  categories,
  children,
  onMore
}: SectionBlockProps) {
  return <section className="py-6 flex flex-col gap-4" data-id="element-90">
      <div className="px-4 flex items-center justify-between" data-id="element-91">
        <h2 className="text-2xl font-bold text-[#333333] tracking-tight" data-id="element-92">
          {title}
        </h2>
        <button onClick={onMore} className="flex items-center gap-0.5 text-sm text-[#999999] hover:text-[#66CADA] transition-colors" data-id="element-93">
          查看更多
          <ChevronRight className="size-4" data-id="element-94" />
        </button>
      </div>

      <div className="px-4 overflow-x-auto no-scrollbar" data-id="element-95">
        <Tabs defaultValue={categories[0]} className="w-auto" data-id="element-96">
          <TabsList className="bg-transparent p-0 h-auto gap-2" data-id="element-97">
            {categories.map(cat => <TabsTrigger key={cat} value={cat} className="data-[state=active]:bg-[#66CADA] data-[state=active]:text-white bg-white text-[#666666] border border-gray-100 rounded-full px-4 py-1.5 text-sm font-medium transition-all" data-id="element-98">
                {cat}
              </TabsTrigger>)}
          </TabsList>
        </Tabs>
      </div>

      <div className="mt-2" data-id="element-99">{children}</div>
    </section>;
}